// extracted by mini-css-extract-plugin
export default {"LoggedInPageTemplate":"LoggedInPageTemplate_LoggedInPageTemplate__zhpBQ"};